// app-user · Account tab strings that the design handoff chrome set (app-strings.ts,
// `app.account.*`) does not carry: group titles, profile card, edit sheet, parameterised
// deactivation rows, OTP chrome, guest gate, the push-off row, the truthful deactivation
// outcome. Spread into en.ts / bn.ts.
export const appEnAccount = {
  'app.account.photo': 'photo',
  'app.account.changePhoto': 'Change photo',
  'app.account.editProfile': 'Edit profile',
  'app.account.editName': 'Name',
  'app.account.editEmail': 'Email (optional)',
  'app.account.editEmailBad': 'Enter a valid email address.',
  'app.account.editNameBad': 'Enter your name.',
  'app.account.editSave': 'Save',
  'app.account.profileSaved': 'Profile saved',
  'app.account.saveFailed': 'Couldn’t save. Try again.',
  'app.account.versionLine': '{brand} v{version}',
  'app.account.groupActivity': 'Activity',
  'app.account.groupPreferences': 'Preferences',
  'app.account.groupSupport': 'Support',
  'app.account.groupAccount': 'Account',
  'app.account.guestT': 'Sign in to open your account',
  'app.account.guestB': 'Your bookings, passes and saved places are tied to your phone number.',
  'app.account.guestCta': 'Sign in',
  'app.account.contactCall': 'Call support',
  'app.account.contactWhatsapp': 'WhatsApp support',
  'app.account.contactEmail': 'Email support',
  'app.account.offlineAction': 'You’re offline. Reconnect to continue.',
  'app.account.pushOff': 'Push is off on this phone',
  'app.account.pushTurnOn': 'Turn on',
  'app.account.deactivateSheet.blkUpcoming': 'Upcoming booking · {name}',
  'app.account.deactivateSheet.blkPayment': 'Payment under check · {name}',
  'app.account.deactivateSheet.blkCheckFailed': 'Couldn’t check your bookings. Try again.',
  'app.account.deactivateSheet.otpBody': 'Enter the 6-digit code sent to {phone}.',
  'app.account.deactivateSheet.otpA11y': 'Enter the 6-digit code',
  'app.account.deactivateSheet.resendIn': 'Resend in {time}',
  'app.account.deactivateSheet.resend': 'Resend code',
  'app.account.deactivateSheet.resendLimit': 'Too many codes sent. Try again in a few minutes.',
  'app.account.deactivateSheet.errWrong': 'That code is not right. Check the SMS and try again.',
  'app.account.deactivateSheet.errLocked': 'Too many wrong tries. Request a new code.',
  'app.account.deactivateSheet.errRate': 'Too many requests. Please wait a minute and try again.',
  'app.account.deactivateSheet.errSend': 'We could not send the code. Check your connection and try again.',
  'app.account.deactivateSheet.errRequest': 'We could not send your request. Try again.',
  'app.account.deactivateSheet.signedOutOnly': 'You’re signed out on this phone. Your account stays active until deactivation is available.',
  'app.account.deactivateSheet.deactivatedToast': 'Your account is deactivated. Sign in again to come back.',
  'app.account.deactivateSheet.closeA11y': 'Close',
  'app.account.notificationSettings.switchA11y': '{row} · {channel}',
  'app.account.notificationSettings.saveFailed': 'Couldn’t save your notification settings. Try again.',
} as const satisfies Record<string, string>;

export const appBnAccount = {
  'app.account.photo': 'ছবি',
  'app.account.changePhoto': 'ছবি বদলান',
  'app.account.editProfile': 'প্রোফাইল এডিট করুন',
  'app.account.editName': 'নাম',
  'app.account.editEmail': 'ইমেইল (ঐচ্ছিক)',
  'app.account.editEmailBad': 'সঠিক ইমেইল ঠিকানা দিন।',
  'app.account.editNameBad': 'আপনার নাম দিন।',
  'app.account.editSave': 'সেভ করুন',
  'app.account.profileSaved': 'প্রোফাইল সেভ হয়েছে',
  'app.account.saveFailed': 'সেভ করা যায়নি। আবার চেষ্টা করুন।',
  'app.account.versionLine': '{brand} v{version}',
  'app.account.groupActivity': 'আমার কার্যক্রম',
  'app.account.groupPreferences': 'সেটিংস',
  'app.account.groupSupport': 'সহায়তা',
  'app.account.groupAccount': 'অ্যাকাউন্ট',
  'app.account.guestT': 'অ্যাকাউন্ট খুলতে সাইন ইন করুন',
  'app.account.guestB': 'আপনার বুকিং, পাস ও সেভ করা জায়গা আপনার ফোন নম্বরের সাথে যুক্ত।',
  'app.account.guestCta': 'সাইন ইন',
  'app.account.contactCall': 'সাপোর্টে কল করুন',
  'app.account.contactWhatsapp': 'সাপোর্টে হোয়াটসঅ্যাপ করুন',
  'app.account.contactEmail': 'সাপোর্টে ইমেইল করুন',
  'app.account.offlineAction': 'আপনি অফলাইনে। এগিয়ে যেতে ইন্টারনেটে যুক্ত হোন।',
  'app.account.pushOff': 'এই ফোনে পুশ বন্ধ আছে',
  'app.account.pushTurnOn': 'চালু করুন',
  'app.account.deactivateSheet.blkUpcoming': 'আসন্ন বুকিং · {name}',
  'app.account.deactivateSheet.blkPayment': 'পেমেন্ট যাচাই চলছে · {name}',
  'app.account.deactivateSheet.blkCheckFailed': 'আপনার বুকিং যাচাই করা যায়নি। আবার চেষ্টা করুন।',
  'app.account.deactivateSheet.otpBody': '{phone} নম্বরে পাঠানো ৬ সংখ্যার কোড দিন।',
  'app.account.deactivateSheet.otpA11y': '৬ সংখ্যার কোড দিন',
  'app.account.deactivateSheet.resendIn': 'আবার পাঠান {time}',
  'app.account.deactivateSheet.resend': 'আবার কোড পাঠান',
  'app.account.deactivateSheet.resendLimit': 'অনেকবার কোড পাঠানো হয়েছে। কয়েক মিনিট পরে আবার চেষ্টা করুন।',
  'app.account.deactivateSheet.errWrong': 'কোডটি সঠিক নয়। এসএমএস দেখে আবার চেষ্টা করুন।',
  'app.account.deactivateSheet.errLocked': 'অনেকবার ভুল হয়েছে। নতুন কোড চান।',
  'app.account.deactivateSheet.errRate': 'অনেক বেশি অনুরোধ। এক মিনিট অপেক্ষা করে আবার চেষ্টা করুন।',
  'app.account.deactivateSheet.errSend': 'কোড পাঠানো যায়নি। ইন্টারনেট দেখে আবার চেষ্টা করুন।',
  'app.account.deactivateSheet.errRequest': 'আপনার অনুরোধ পাঠানো যায়নি। আবার চেষ্টা করুন।',
  'app.account.deactivateSheet.signedOutOnly': 'এই ফোনে আপনি সাইন আউট হয়েছেন। নিষ্ক্রিয় করার সুবিধা চালু না হওয়া পর্যন্ত আপনার অ্যাকাউন্ট সক্রিয় থাকবে।',
  'app.account.deactivateSheet.deactivatedToast': 'আপনার অ্যাকাউন্ট নিষ্ক্রিয় হয়েছে। ফিরে আসতে আবার সাইন ইন করুন।',
  'app.account.deactivateSheet.closeA11y': 'বন্ধ করুন',
  'app.account.notificationSettings.switchA11y': '{row} · {channel}',
  'app.account.notificationSettings.saveFailed': 'নোটিফিকেশন সেটিংস সেভ করা যায়নি। আবার চেষ্টা করুন।',
} as const satisfies Record<string, string>;
